export default __webpack_public_path__ + "static/media/GR6 1A-1B-1C-2D-1EC.53492728.jpg";